import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f928175"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-faq" }
const _hoisted_2 = { class: "box-list" }
const _hoisted_3 = { class: "row g-3 row-cols-2 row-cols-md-3 row-cols-lg-4" }
const _hoisted_4 = { class: "name" }

import { faqSectionsStore } from '@/stores';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_AppAutoHeight = _resolveComponent("AppAutoHeight")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqSectionsStore).data, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.id,
            to: { name: 'faq.section', params: { id: item.id } },
            class: "faq-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppAutoHeight, {
                class: "image-container",
                height: "33.33%",
                "image-url": item.image?.url
              }, null, 8, ["image-url"]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ])
  ]))
}
}

})